import 'imagesLoaded';

export default {
  isMobileAndroid() {
    return navigator.userAgent.match(/Android/i);
  },
  isMobileBlackBerry() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  isMobileiOS() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  isMobileOpera() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  isMobileWindows() {
    return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
  },
  isMobile: function () {
    return (this.isMobileAndroid() || this.isMobileBlackBerry() || this.isMobileiOS() || this.isMobileOpera() || this.isMobileWindows());
  },
  init() {
    let vm = this;
    if (vm.isMobile()) {
      $('body').addClass('mobile');
    }

    jQuery(document).ready(function () {
      jQuery('body').imagesLoaded({background: true}, function () {
        vm.initEqual();
      });
    });
  },

  initEqual() {
    console.log('initEqual');

    //Social Share
    $('.share-content').jsSocials({
      showLabel: false,
      shareIn: 'popup',
      showCount: false,
      shares: [
        {
          share: 'facebook',
        },
        {
          share: 'linkedin',
        },
        {
          share: 'twitter',
        },
      ],
    });

    $('.owl-carousel.slider').owlCarousel({
      items: 1,
      loop: true,
      margin: 0,
      nav: false,
      dot: true,
      autoplay: true,
    });
    $('.owl-carousel.formazione-carousel').owlCarousel({
      margin: 30,
      nav: false,
      autoplay: false,
      responsive: {
        0: {
          loop: true,
          dot: true,
          items: 1,
        },
        768: {
          items: 2,
          loop: true,
        },
        1024: {
          dot: false,
          items: 3,
          loop: false,
        },
      },
    });

    $('#hamburger').click(function () {
      $(this).toggleClass('open');
      $('header nav').slideToggle();
    });
/*
    $('#search-button').click(function () {
      $('.search-input-wrap').fadeIn();
    });

    $('.close-mobile').click(function () {
      $('.search-input-wrap').fadeOut();
    });*/

    $('.backtotop').click(function () {
      $('html, body').animate({scrollTop: 0}, 200);
    });

    $('main .aside-sommario > h3').click(function () {
      $('main .aside-sommario .list').slideToggle();
      $(this).toggleClass('open');
    });

    $('.select-argomento').select2({
      placeholder: 'Scegli...',
      allowClear: true,
    });

    var options = {

      url: function () {
        return window.idnah_ajaxurl;
      },

      getValue: function (element) {
        return element.nome;
      },

      ajaxSettings: {
        method: 'POST',
        data: {
          action: 'loadAuthorData',
          dataType: 'json',
        },
      },

      preparePostData: function (data) {
        data.phrase = $('#autore').val();
        return data;
      },

      requestDelay: 400,

      // theme: 'round',
    };

    $('#autore').easyAutocomplete(options);

    $('.aside-sommario .list a').click(function (event) {
      event.preventDefault();
      // console.log($(this).attr('href').substring(1));
      $.scrollTo(document.getElementById($(this).attr('href').substring(1)), 500);
    });

    /*window.cookieconsent.initialise({
      'palette': {
        'popup': {
          'background': '#000000',
        },
        'button': {
          'background': '#cf102d',
        },
      },
      'content': {
        'link': 'Consulta la Cookie Policy.',
        'message': 'Questo sito utilizza cookies tecnici funzionali all\'esperienza di navigazione e cookies, anche di terze parti, per offrirti servizi in linea con le tue preferenze. Se vuoi saperne di più o negare il consenso a tutti o ad alcuni dei suddetti cookies clicca il pulsante Informativa estesa. Se accetti cliccando su Accetta e continua acconsenti all\'uso dei cookie.',
        'dismiss': 'OK',
        'href': '/cookie-policy',
      },
      'position': 'bottom-right',
    });*/

    $('.aside-newsletter form').on('submit', function () {

				window._iub.cons_instructions.push(['submit', {
					writeOnLocalStorage: false, // default: false
					form: {
						selector: jQuery('#form-custom-newsletter'),
						map: {
							subject: {
								first_name: 'nn',
								last_name: 'ns',
								email: 'ne',
							},
							preferences: {
								privacy: 'ny',
								},
							},
					},
					consent: {
						legal_notices: [
							{ identifier: 'privacy_policy' },                   
							{ identifier: 'cookie_policy'  },
							{ identifier: 'term' },
							],
						},
					},
					{
						success: function(response) {
						console.log(response);
						}, 
						error: function(response) {
						console.log(response);
						},
					},
				]);

      this.submit();

    });
    jQuery('#close-modal-search').click(function () {
      jQuery('.modale-search').fadeOut();
  });

  jQuery('.ricerca-avanzata-sidebar').click(function () {
      jQuery('.modale-search').fadeIn().css('display','flex');
  });

  var objimg = jQuery('.item-banner');
  var numitem=objimg.length;
  var numcount=0;
  var theInterval;
  if (jQuery('.slideshow-banner')[0]){
      startSlide();
  }

  function startSlide() {
      theInterval = setInterval(timerSlides, 2000);
  }
  
  console.log(theInterval);

  function stopSlide() {
      clearInterval(theInterval);
  }

  jQuery('.next-banner').click(function(){
      numcount++;
      if (numcount > numitem) {
          numcount = 1
      }
      jQuery(objimg).removeClass( 'active' );
      jQuery(objimg[numcount-1]).addClass( 'active' );
      stopSlide() ;
  });

  jQuery('.prev-banner').click(function(){
      numcount--;
      if (numcount < 0) {
          numcount = numitem-1;
      }
      jQuery(objimg).removeClass( 'active' );
      jQuery(objimg[numcount]).addClass( 'active' );
      stopSlide() ;
  });


  function timerSlides() {
      numcount++;
      if (numcount > numitem) {
          numcount = 1
      }
          jQuery(objimg).removeClass( 'active' );
          jQuery(objimg[numcount-1]).addClass( 'active' );
      } 

      jQuery('#custom_login').submit(function (event) {
        if (jQuery('#user_login').val() === '' || jQuery('#user_pass').val() === '') {
          jQuery('.form-custom-login-error').text('Inserisci username e password');
          event.preventDefault();
          return false;
        }
      })
  

},

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js